import { create } from 'zustand';

import type { User } from '@models/user';

type MeState = {
  me: User | null;
  login: (user: User) => void;
  logout: () => void;
};

export const useMeStorage = create<MeState>((set) => ({
  me: null,
  login: (me: User) => set({ me }),
  logout: () => set({ me: null }),
}));

export const useMeStore = () => useMeStorage((state) => state.me);
export const useMeLogoutStore = () => useMeStorage((state) => state.logout);
export const useMeLoginStore = () => useMeStorage((state) => state.login);
